module.exports = require("npm:element-closest@2.0.2/element-closest.js");